// Pojednostavljeni model fabrike za 3D prikaz skladišta.
// Mere su PROCENJENE sa dron snimaka (Images/DJI_0895-0896, razmera po automobilima ~0.11 m/px)
// i mogu se ovde ispraviti kada budu poznate tačne dimenzije.
// Koordinatni sistem: metri, X = levo-desno na snimku odozgo, Z = gore-dole, Y = visina.

export type Point2 = [number, number]; // [x, z]

export type SiteBuilding = {
  id: string;
  label?: string;
  x: number; // centar
  z: number;
  width: number; // po X
  depth: number; // po Z
  height: number;
  color: string;
  roofColor?: string;
  // Zgrada u kojoj postoji skladišni prostor; može se prikazati iznutra (providni zidovi, bez krova)
  hasInterior?: boolean;
};

export type ConcreteZone = {
  id: string;
  label: string;
  color: string;
  polygon: Point2[];
  // Gde stoji natpis zone (van mesta gde se obično crtaju lokacije)
  labelAt: Point2;
  // Zona unutar zgrada (lokacije se tu crtaju kroz prikaz hale iznutra)
  indoor?: boolean;
  buildingIds?: string[];
};

export const SITE_BUILDINGS: SiteBuilding[] = [
  { id: 'hall-north', label: 'Proizvodna hala', x: -14.1, z: -11.8, width: 93.2, depth: 25.9, height: 11, color: '#5b6472', roofColor: '#d7dadf', hasInterior: true },
  { id: 'hall-south', x: -22.2, z: 13.5, width: 77, depth: 24.8, height: 11, color: '#5b6472', roofColor: '#d7dadf', hasInterior: true },
  { id: 'annex', x: 43.7, z: -5.2, width: 21.5, depth: 44.6, height: 12, color: '#5b6472', roofColor: '#d7dadf' },
  { id: 'tower', x: 51.7, z: -35.2, width: 20.9, depth: 15.4, height: 20, color: '#5b6472', roofColor: '#d7dadf' },
  { id: 'office', label: 'Upravna zgrada', x: 74.5, z: -20.5, width: 34.6, depth: 13, height: 10, color: '#f1f2f4', roofColor: '#b8b2a3' },
  { id: 'office-low', x: 58.9, z: -9.1, width: 8.8, depth: 9.4, height: 4, color: '#f1f2f4', roofColor: '#c9ccd1' }
];

// Odžak između upravne zgrade i aneksa hale (po oznaci iz Images/Dopuna.jpeg)
export const SITE_CHIMNEY = { x: 55.8, z: -20.5, radius: 1, height: 30 };

export const CONCRETE_ZONES: ConcreteZone[] = [
  {
    id: 'hall-interior',
    label: 'Proizvodna hala (unutra)',
    color: '#d4d1c9',
    labelAt: [-22, 23.5],
    indoor: true,
    buildingIds: ['hall-north', 'hall-south'],
    // Zapadni deo hale po oznaci iz Images/Proizvodnja.jpeg: južna polovina severnog krila + celo južno krilo
    polygon: [
      [-60.7, -12],
      [16.3, -12],
      [16.3, 25.9],
      [-60.7, 25.9]
    ]
  },
  {
    id: 'yard',
    label: 'Dvorište ispred hale',
    color: '#b9bcbf',
    labelAt: [101, -36],
    // Obuhvata i površinu oko upravne zgrade i severno od nje do tornja (zgrade se ne mogu zauzeti, vidi buildingAt)
    polygon: [
      [16.3, 1.1],
      [33, 1.1],
      [33, 17.1],
      [54.5, 17.1],
      [54.5, -27.5],
      [62.2, -27.5],
      [62.2, -43],
      [110, -43],
      [110, 30.8],
      [-60.7, 30.8],
      [-60.7, 25.9],
      [16.3, 25.9]
    ]
  },
  {
    id: 'behind-hall',
    label: 'Traka iza hale',
    color: '#aeb2b6',
    labelAt: [-25, -30.5],
    // Traka uz zadnji zid hale
    polygon: [
      [-60.7, -24.8],
      [-60.7, -28.2],
      [9.9, -28.2],
      [9.9, -24.8]
    ]
  },
  {
    id: 'new-concrete',
    label: 'Novi betonski plato',
    color: '#c8cacb',
    labelAt: [11, 48.5],
    // Duž cele hale, naslanja se na traku dvorišta ispred hale
    polygon: [
      [-60.7, 30.8],
      [82.5, 30.8],
      [82.5, 46.5],
      [-60.7, 46.5]
    ]
  }
];

// Početni pogled kamere
// Pogled iz ugla dvorišta i novog platoa, kao na dron snimku sa oznakom betona
export const SITE_CAMERA = { position: [125, 75, 115] as [number, number, number], target: [20, 0, 5] as [number, number, number] };

// Dimenzije europalete (m) za predlog broja redova/mesta
export const PALLET = { length: 1.2, width: 0.8, height: 1.1 };
